import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_OPERATOR_MASTER = createActionTypes('FETCH_OPERATOR_MASTER');
export const GET_OPERATOR_MASTER = createActionTypes('GET_OPERATOR_MASTER');
export const ADD_OPERATOR_MASTER = createActionTypes('ADD_OPERATOR_MASTER');
export const UPDATE_OPERATOR_MASTER = createActionTypes('UPDATE_OPERATOR_MASTER');
export const DELETE_OPERATOR_MASTER = createActionTypes('DELETE_OPERATOR_MASTER');
